module.exports = __webpack_public_path__ + "img/i-zcy-bg-2.7d2ca329.png";